import AppLoader from '@/components/AppLoader';
import { ROUTE_DASHBOARD_TEAMS_PAGE } from '@/constants/routes';
import HeaderTemplate from '@/templates/Header.template';
import { Box, Button, Container, Heading } from '@chakra-ui/react';
import { FiArrowLeft, FiUserPlus } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import AddMemberModal from './components/add-member-modal/add-member.modal';
import MembersTable from './components/members-table/members-table';
import { useTeamPage } from './team.controller';

export default function TeamPage() {
	const { t, query, organizationId, modalDisclosure, removeMember } = useTeamPage();

	if (!query.data) {
		return <AppLoader />;
	}

	return (
		<Container maxW="container.md" padding="0" h="full" overflow="auto" display="grid" gridTemplateRows="auto 1fr">
			<HeaderTemplate
				left={
					<Button as={Link} to={ROUTE_DASHBOARD_TEAMS_PAGE} size="sm" leftIcon={<FiArrowLeft />}>
						{t('Back')}
					</Button>
				}
				center={
					<Heading textAlign="center" size="sm">
						{t('Team')}
					</Heading>
				}
				right={
					<Button colorScheme="primary" size="sm" leftIcon={<FiUserPlus />} onClick={modalDisclosure.onOpen}>
						{t('Add member')}
					</Button>
				}
			/>
			<Box mt={4}>
				<AddMemberModal
					close={() => modalDisclosure.onClose()}
					isOpen={modalDisclosure.isOpen}
					organizationId={organizationId}
				/>
				<MembersTable members={query.data.members} onRemoveMember={removeMember} />
			</Box>
		</Container>
	);
}
